import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
export default new Router({
  base: "medical-agreement",
  mode: "history", // history  hash
  routes: [
    /**
     * 用户政策和隐私协议
     */
    {
      path: "/JCHealth_user_agreement_zh",
      name: "/JCHealth_user_agreement_zh",
      component: (resolve) =>
        require(["@/pages/agreement/JCHealth/user_agreement_zh"], resolve),
    },
    {
      path: "/JCHealth_user_agreement_en",
      name: "/JCHealth_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/JCHealth/user_agreement_en"], resolve),
    },
    {
      path: "/JCHealth_privacy_policy_zh",
      name: "/JCHealth_privacy_policy_zh",
      component: (resolve) =>
        require(["@/pages/agreement/JCHealth/privacy_policy_zh"], resolve),
    },
    {
      path: "/JCHealth_privacy_policy_en",
      name: "/JCHealth_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/JCHealth/privacy_policy_en"], resolve),
    },
    {
      path: "/JCLife_user_agreement_zh",
      name: "/JCLife_user_agreement_zh",
      component: (resolve) =>
        require(["@/pages/agreement/JCLife/user_agreement_zh"], resolve),
    },
    {
      path: "/JCLife_user_agreement_en",
      name: "/JCLife_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/JCLife/user_agreement_en"], resolve),
    },
    {
      path: "/JCLife_privacy_policy_zh",
      name: "/JCLife_privacy_policy_zh",
      component: (resolve) =>
        require(["@/pages/agreement/JCLife/privacy_policy_zh"], resolve),
    },
    {
      path: "/JCLife_privacy_policy_en",
      name: "/JCLife_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/JCLife/privacy_policy_en"], resolve),
    },

    {
      path: "/HappySleep_user_agreement_zh",
      name: "/HappySleep_user_agreement_zh",
      component: (resolve) =>
        require(["@/pages/agreement/HappySleep/user_agreement_zh"], resolve),
    },
    {
      path: "/HappySleep_user_agreement_en",
      name: "/HappySleep_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/HappySleep/user_agreement_en"], resolve),
    },
    {
      path: "/HappySleep_privacy_policy_zh",
      name: "/HappySleep_privacy_policy_zh",
      component: (resolve) =>
        require(["@/pages/agreement/HappySleep/privacy_policy_zh"], resolve),
    },
    {
      path: "/HappySleep_privacy_policy_en",
      name: "/HappySleep_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/HappySleep/privacy_policy_en"], resolve),
    },
    {
      path: "/BabyThermo_user_agreement_zh",
      name: "/BabyThermo_user_agreement_zh",
      component: (resolve) =>
        require(["@/pages/agreement/BabyThermo/user_agreement_zh"], resolve),
    },
    {
      path: "/BabyThermo_user_agreement_en",
      name: "/BabyThermo_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/BabyThermo/user_agreement_en"], resolve),
    },
    {
      path: "/BabyThermo_privacy_policy_zh",
      name: "/BabyThermo_privacy_policy_zh",
      component: (resolve) =>
        require(["@/pages/agreement/BabyThermo/privacy_policy_zh"], resolve),
    },
    {
      path: "/BabyThermo_privacy_policy_en",
      name: "/BabyThermo_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/BabyThermo/privacy_policy_en"], resolve),
    },
    {
      path: "/JCWear_user_agreement_zh",
      name: "/JCWear_user_agreement_zh",
      component: (resolve) =>
        require(["@/pages/agreement/JCWear/user_agreement_zh"], resolve),
    },
    {
      path: "/JCWear_user_agreement_en",
      name: "/JCWear_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/JCWear/user_agreement_en"], resolve),
    },
    {
      path: "/JCWear_user_agreement_ko",
      name: "/JCWear_user_agreement_ko",
      component: (resolve) =>
        require(["@/pages/agreement/JCWear/user_agreement_ko"], resolve),
    },
    {
      path: "/JCWear_user_agreement_ja",
      name: "/JCWear_user_agreement_ja",
      component: (resolve) =>
        require(["@/pages/agreement/JCWear/user_agreement_ja"], resolve),
    },
    {
      path: "/JCWear_privacy_policy_zh",
      name: "/JCWear_privacy_policy_zh",
      component: (resolve) =>
        require(["@/pages/agreement/JCWear/privacy_policy_zh"], resolve),
    },
    {
      path: "/JCWear_privacy_policy_ko",
      name: "/JCWear_privacy_policy_ko",
      component: (resolve) =>
        require(["@/pages/agreement/JCWear/privacy_policy_ko"], resolve),
    },
    {
      path: "/JCWear_privacy_policy_ja",
      name: "/JCWear_privacy_policy_ja",
      component: (resolve) =>
        require(["@/pages/agreement/JCWear/privacy_policy_ja"], resolve),
    },
    {
      path: "/JCWear_privacy_policy_en",
      name: "/JCWear_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/JCWear/privacy_policy_en"], resolve),
    },

    {
      path: "/JCWearPro_user_agreement_zh",
      name: "/JCWearPro_user_agreement_zh",
      component: (resolve) =>
        require(["@/pages/agreement/JCWearPro/user_agreement_zh"], resolve),
    },
    {
      path: "/JCWearPro_user_agreement_en",
      name: "/JCWearPro_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/JCWearPro/user_agreement_en"], resolve),
    },
    {
      path: "/JCWearPro_user_agreement_ko",
      name: "/JCWearPro_user_agreement_ko",
      component: (resolve) =>
        require(["@/pages/agreement/JCWearPro/user_agreement_ko"], resolve),
    },

    {
      path: "/JCWearPro_privacy_policy_zh",
      name: "/JCWearPro_privacy_policy_zh",
      component: (resolve) =>
        require(["@/pages/agreement/JCWearPro/privacy_policy_zh"], resolve),
    },
    {
      path: "/JCWearPro_privacy_policy_ko",
      name: "/JCWearPro_privacy_policy_ko",
      component: (resolve) =>
        require(["@/pages/agreement/JCWearPro/privacy_policy_ko"], resolve),
    },

    {
      path: "/JCWearPro_privacy_policy_en",
      name: "/JCWearPro_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/JCWearPro/privacy_policy_en"], resolve),
    },

    {
      path: "/JCRing_user_agreement_th",
      name: "/JCRing_user_agreement_th",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/user_agreement_th"], resolve),
    },
    {
      path: "/JCRing_user_agreement_zh",
      name: "/JCRing_user_agreement_zh",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/user_agreement_zh"], resolve),
    },
    {
      path: "/JCRing_user_agreement_en",
      name: "/JCRing_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/user_agreement_en"], resolve),
    },

    {
      path: "/JCRing_user_agreement_fi",
      name: "/JCRing_user_agreement_fi",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/user_agreement_fi"], resolve),
    },

    {
      path: "/JCRing_user_agreement_ja",
      name: "/JCRing_user_agreement_ja",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/user_agreement_ja"], resolve),
    },

    {
      path: "/JCRing_user_agreement_pl",
      name: "/JCRing_user_agreement_pl",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/user_agreement_pl"], resolve),
    },
    {
      path: "/JCRing_user_agreement_ru",
      name: "/JCRing_user_agreement_ru",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/user_agreement_ru"], resolve),
    },
    {
      path: "/JCRing_user_agreement_vi",
      name: "/JCRing_user_agreement_vi",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/user_agreement_vi"], resolve),
    },
    {
      path: "/JCRing_user_agreement_ru",
      name: "/JCRing_user_agreement_ru",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/user_agreement_ru"], resolve),
    },
    {
      path: "/JCRing_user_agreement_zhhk",
      name: "/JCRing_user_agreement_zhhk",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/user_agreement_zhhk"], resolve),
    },

    {
      path: "/JCRing_user_agreement_es",
      name: "/JCRing_user_agreement_es",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/user_agreement_es"], resolve),
    },

    {
      path: "/JCRing_user_agreement_pt",
      name: "/JCRing_user_agreement_pt",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/user_agreement_pt"], resolve),
    },

    {
      path: "/JCRing_user_agreement_it",
      name: "/JCRing_user_agreement_it",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/user_agreement_it"], resolve),
    },
    {
      path: "/JCRing_user_agreement_de",
      name: "/JCRing_user_agreement_de",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/user_agreement_de"], resolve),
    },
    {
      path: "/JCRing_user_agreement_cs",
      name: "/JCRing_user_agreement_cs",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/user_agreement_cs"], resolve),
    },
    {
      path: "/JCRing_user_agreement_fr",
      name: "/JCRing_user_agreement_fr",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/user_agreement_fr"], resolve),
    },
    {
      path: "/JCRing_user_agreement_ko",
      name: "/JCRing_user_agreement_ko",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/user_agreement_ko"], resolve),
    },

    {
      path: "/JCRing_privacy_policy_ko",
      name: "/JCRing_privacy_policy_ko",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/privacy_policy_ko"], resolve),
    },
    {
      path: "/JCRing_privacy_policy_fr",
      name: "/JCRing_privacy_policy_fr",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/privacy_policy_fr"], resolve),
    },

    {
      path: "/JCRing_privacy_policy_cs",
      name: "/JCRing_privacy_policy_cs",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/privacy_policy_cs"], resolve),
    },
    {
      path: "/JCRing_privacy_policy_de",
      name: "/JCRing_privacy_policy_de",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/privacy_policy_de"], resolve),
    },

    {
      path: "/JCRing_privacy_policy_it",
      name: "/JCRing_privacy_policy_it",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/privacy_policy_it"], resolve),
    },
    {
      path: "/JCRing_privacy_policy_pt",
      name: "/JCRing_privacy_policy_pt",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/privacy_policy_pt"], resolve),
    },
    {
      path: "/JCRing_privacy_policy_es",
      name: "/JCRing_privacy_policy_es",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/privacy_policy_es"], resolve),
    },

    {
      path: "/JCRing_privacy_policy_ja",
      name: "/JCRing_privacy_policy_ja",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/privacy_policy_ja"], resolve),
    },
    {
      path: "/JCRing_privacy_policy_fi",
      name: "/JCRing_privacy_policy_fi",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/privacy_policy_fi"], resolve),
    },

    {
      path: "/JCRing_privacy_policy_zh",
      name: "/JCRing_privacy_policy_zh",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/privacy_policy_zh"], resolve),
    },
    {
      path: "/JCRing_privacy_policy_th",
      name: "/JCRing_privacy_policy_th",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/privacy_policy_th"], resolve),
    },

    {
      path: "/JCRing_privacy_policy_en",
      name: "/JCRing_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/privacy_policy_en"], resolve),
    },
    {
      path: "/JCRing_privacy_policy_ar",
      name: "/JCRing_privacy_policy_ar",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/privacy_policy_ar"], resolve),
    },
    {
      path: "/JCRing_privacy_policy_pl",
      name: "/JCRing_privacy_policy_pl",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/privacy_policy_pl"], resolve),
    },
    {
      path: "/JCRing_privacy_policy_vi",
      name: "/JCRing_privacy_policy_vi",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/privacy_policy_vi"], resolve),
    },
    {
      path: "/JCRing_privacy_policy_ru",
      name: "/JCRing_privacy_policy_ru",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/privacy_policy_ru"], resolve),
    },
    {
      path: "/JCRing_privacy_policy_zhhk",
      name: "/JCRing_privacy_policy_zhhk",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/privacy_policy_zhhk"], resolve),
    },

    {
      path: "/youhonghealth_user_agreement_th",
      name: "/youhonghealth_user_agreement_th",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/user_agreement_th"], resolve),
    },
    {
      path: "/youhonghealth_user_agreement_zh",
      name: "/youhonghealth_user_agreement_zh",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/user_agreement_zh"], resolve),
    },
    {
      path: "/youhonghealth_user_agreement_en",
      name: "/youhonghealth_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/user_agreement_en"], resolve),
    },

    {
      path: "/youhonghealth_user_agreement_fi",
      name: "/youhonghealth_user_agreement_fi",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/user_agreement_fi"], resolve),
    },

    {
      path: "/youhonghealth_user_agreement_ja",
      name: "/youhonghealth_user_agreement_ja",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/user_agreement_ja"], resolve),
    },

    {
      path: "/youhonghealth_user_agreement_pl",
      name: "/youhonghealth_user_agreement_pl",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/user_agreement_pl"], resolve),
    },
    {
      path: "/youhonghealth_user_agreement_ru",
      name: "/youhonghealth_user_agreement_ru",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/user_agreement_ru"], resolve),
    },
    {
      path: "/youhonghealth_user_agreement_vi",
      name: "/youhonghealth_user_agreement_vi",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/user_agreement_vi"], resolve),
    },
    {
      path: "/youhonghealth_user_agreement_ru",
      name: "/youhonghealth_user_agreement_ru",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/user_agreement_ru"], resolve),
    },
    {
      path: "/youhonghealth_user_agreement_zhhk",
      name: "/youhonghealth_user_agreement_zhhk",
      component: (resolve) =>
        require([
          "@/pages/agreement/youhonghealth/user_agreement_zhhk",
        ], resolve),
    },

    {
      path: "/youhonghealth_user_agreement_es",
      name: "/youhonghealth_user_agreement_es",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/user_agreement_es"], resolve),
    },

    {
      path: "/youhonghealth_user_agreement_pt",
      name: "/youhonghealth_user_agreement_pt",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/user_agreement_pt"], resolve),
    },

    {
      path: "/youhonghealth_user_agreement_it",
      name: "/youhonghealth_user_agreement_it",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/user_agreement_it"], resolve),
    },
    {
      path: "/youhonghealth_user_agreement_de",
      name: "/youhonghealth_user_agreement_de",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/user_agreement_de"], resolve),
    },
    {
      path: "/youhonghealth_user_agreement_cs",
      name: "/youhonghealth_user_agreement_cs",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/user_agreement_cs"], resolve),
    },
    {
      path: "/youhonghealth_user_agreement_fr",
      name: "/youhonghealth_user_agreement_fr",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/user_agreement_fr"], resolve),
    },
    {
      path: "/youhonghealth_user_agreement_ko",
      name: "/youhonghealth_user_agreement_ko",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/user_agreement_ko"], resolve),
    },

    {
      path: "/youhonghealth_privacy_policy_ko",
      name: "/youhonghealth_privacy_policy_ko",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/privacy_policy_ko"], resolve),
    },
    {
      path: "/youhonghealth_privacy_policy_fr",
      name: "/youhonghealth_privacy_policy_fr",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/privacy_policy_fr"], resolve),
    },

    {
      path: "/youhonghealth_privacy_policy_cs",
      name: "/youhonghealth_privacy_policy_cs",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/privacy_policy_cs"], resolve),
    },
    {
      path: "/youhonghealth_privacy_policy_de",
      name: "/youhonghealth_privacy_policy_de",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/privacy_policy_de"], resolve),
    },

    {
      path: "/youhonghealth_privacy_policy_it",
      name: "/youhonghealth_privacy_policy_it",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/privacy_policy_it"], resolve),
    },
    {
      path: "/youhonghealth_privacy_policy_pt",
      name: "/youhonghealth_privacy_policy_pt",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/privacy_policy_pt"], resolve),
    },
    {
      path: "/youhonghealth_privacy_policy_es",
      name: "/youhonghealth_privacy_policy_es",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/privacy_policy_es"], resolve),
    },

    {
      path: "/youhonghealth_privacy_policy_ja",
      name: "/youhonghealth_privacy_policy_ja",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/privacy_policy_ja"], resolve),
    },
    {
      path: "/youhonghealth_privacy_policy_fi",
      name: "/youhonghealth_privacy_policy_fi",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/privacy_policy_fi"], resolve),
    },

    {
      path: "/youhonghealth_privacy_policy_zh",
      name: "/youhonghealth_privacy_policy_zh",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/privacy_policy_zh"], resolve),
    },
    {
      path: "/youhonghealth_privacy_policy_th",
      name: "/youhonghealth_privacy_policy_th",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/privacy_policy_th"], resolve),
    },

    {
      path: "/youhonghealth_privacy_policy_en",
      name: "/youhonghealth_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/privacy_policy_en"], resolve),
    },
    {
      path: "/youhonghealth_privacy_policy_ar",
      name: "/youhonghealth_privacy_policy_ar",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/privacy_policy_ar"], resolve),
    },
    {
      path: "/youhonghealth_privacy_policy_pl",
      name: "/youhonghealth_privacy_policy_pl",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/privacy_policy_pl"], resolve),
    },
    {
      path: "/youhonghealth_privacy_policy_vi",
      name: "/youhonghealth_privacy_policy_vi",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/privacy_policy_vi"], resolve),
    },
    {
      path: "/youhonghealth_privacy_policy_ru",
      name: "/youhonghealth_privacy_policy_ru",
      component: (resolve) =>
        require(["@/pages/agreement/youhonghealth/privacy_policy_ru"], resolve),
    },
    {
      path: "/youhonghealth_privacy_policy_zhhk",
      name: "/youhonghealth_privacy_policy_zhhk",
      component: (resolve) =>
        require([
          "@/pages/agreement/youhonghealth/privacy_policy_zhhk",
        ], resolve),
    },
    {
      path: "/MyXring_privacy_policy_zh",
      name: "/MyXring_privacy_policy_zh",
      component: (resolve) =>
        require(["@/pages/agreement/MyXring/privacy_policy_zh"], resolve),
    },
    {
      path: "/MyXring_privacy_policy_en",
      name: "/MyXring_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/MyXring/privacy_policy_en"], resolve),
    },

    {
      path: "/MyXring_user_agreement_zh",
      name: "/MyXring_user_agreement_zh",
      component: (resolve) =>
        require(["@/pages/agreement/MyXring/user_agreement_zh"], resolve),
    },
    {
      path: "/MyXring_user_agreement_en",
      name: "/MyXring_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/MyXring/user_agreement_en"], resolve),
    },

    {
      path: "/IBRing_user_agreement_en",
      name: "/IBRing_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/IBRing/user_agreement_en"], resolve),
    },
    {
      path: "/IBRing_user_agreement_ja",
      name: "/IBRing_user_agreement_ja",
      component: (resolve) =>
        require(["@/pages/agreement/IBRing/user_agreement_ja"], resolve),
    },
    {
      path: "/IBRing_privacy_policy_ja",
      name: "/IBRing_privacy_policy_ja",
      component: (resolve) =>
        require(["@/pages/agreement/IBRing/privacy_policy_ja"], resolve),
    },
    {
      path: "/IBRing_privacy_policy_en",
      name: "/IBRing_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/IBRing/privacy_policy_en"], resolve),
    },

    {
      path: "/JCFit_user_agreement_zh",
      name: "/JCFit_user_agreement_zh",
      component: (resolve) =>
        require(["@/pages/agreement/JCFit/user_agreement_zh"], resolve),
    },
    {
      path: "/JCSkip_user_agreement_en",
      name: "/JCSkip_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/JCSkip/user_agreement_en"], resolve),
    },
    {
      path: "/JCSkip_privacy_policy_zh",
      name: "/JCSkip_privacy_policy_zh",
      component: (resolve) =>
        require(["@/pages/agreement/JCSkip/privacy_policy_zh"], resolve),
    },
    {
      path: "/JCSkip_privacy_policy_en",
      name: "/JCSkip_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/JCSkip/privacy_policy_en"], resolve),
    },

    {
      path: "/JCSkip_user_agreement_zh",
      name: "/JCSkip_user_agreement_zh",
      component: (resolve) =>
        require(["@/pages/agreement/JCSkip/user_agreement_zh"], resolve),
    },
    {
      path: "/JCFit_user_agreement_en",
      name: "/JCFit_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/JCFit/user_agreement_en"], resolve),
    },
    {
      path: "/JCFit_privacy_policy_zh",
      name: "/JCFit_privacy_policy_zh",
      component: (resolve) =>
        require(["@/pages/agreement/JCFit/privacy_policy_zh"], resolve),
    },
    {
      path: "/JCFit_privacy_policy_en",
      name: "/JCFit_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/JCFit/privacy_policy_en"], resolve),
    },
    {
      path: "/insixLife_user_agreement_zh",
      name: "/insixLife_user_agreement_zh",
      component: (resolve) =>
        require(["@/pages/agreement/insixLife/user_agreement_zh"], resolve),
    },
    {
      path: "/insixLife_user_agreement_en",
      name: "/insixLife_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/insixLife/user_agreement_en"], resolve),
    },
    {
      path: "/insixLife_privacy_policy_zh",
      name: "/insixLife_privacy_policy_zh",
      component: (resolve) =>
        require(["@/pages/agreement/insixLife/privacy_policy_zh"], resolve),
    },
    {
      path: "/insixLife_privacy_policy_en",
      name: "/insixLife_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/insixLife/privacy_policy_en"], resolve),
    },
    {
      path: "/HART_user_agreement_zh",
      name: "/HART_user_agreement_zh",
      component: (resolve) =>
        require(["@/pages/agreement/HART/user_agreement_zh"], resolve),
    },
    {
      path: "/HART_user_agreement_en",
      name: "/HART_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/HART/user_agreement_en"], resolve),
    },
    {
      path: "/HART_privacy_policy_zh",
      name: "/HART_privacy_policy_zh",
      component: (resolve) =>
        require(["@/pages/agreement/HART/privacy_policy_zh"], resolve),
    },
    {
      path: "/HART_privacy_policy_en",
      name: "/HART_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/HART/privacy_policy_en"], resolve),
    },

    {
      path: "/SmartRing_user_agreement_en",
      name: "/SmartRing_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/SmartRing/user_agreement_en"], resolve),
    },

    {
      path: "/SmartRing_privacy_policy_en",
      name: "/SmartRing_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/SmartRing/privacy_policy_en"], resolve),
    },
    {
      path: "/NoiseSphere_user_agreement_zh",
      name: "/NoiseSphere_user_agreement_zh",
      component: (resolve) =>
        require(["@/pages/agreement/NoiseSphere/user_agreement_zh"], resolve),
    },
    {
      path: "/NoiseSphere_user_agreement_en",
      name: "/NoiseSphere_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/NoiseSphere/user_agreement_en"], resolve),
    },
    {
      path: "/NoiseSphere_privacy_policy_zh",
      name: "/NoiseSphere_privacy_policy_zh",
      component: (resolve) =>
        require(["@/pages/agreement/NoiseSphere/privacy_policy_zh"], resolve),
    },
    {
      path: "/NoiseSphere_privacy_policy_en",
      name: "/NoiseSphere_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/NoiseSphere/privacy_policy_en"], resolve),
    },

    {
      path: "/EZSmartRing_user_agreement_en",
      name: "/EZSmartRing_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/EZSmartRing/user_agreement_en"], resolve),
    },

    {
      path: "/EZSmartRing_privacy_policy_en",
      name: "/EZSmartRing_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/EZSmartRing/privacy_policy_en"], resolve),
    },
    {
      path: "/JCVital_user_agreement_zh",
      name: "/JCVital_user_agreement_zh",
      component: (resolve) =>
        require(["@/pages/agreement/JCVital/user_agreement_zh"], resolve),
    },
    {
      path: "/JCVital_user_agreement_zhhk",
      name: "/JCVital_user_agreement_zhhk",
      component: (resolve) =>
        require(["@/pages/agreement/JCVital/user_agreement_zhhk"], resolve),
    },

    {
      path: "/JCVital_user_agreement_en",
      name: "/JCVital_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/JCVital/user_agreement_en"], resolve),
    },
    {
      path: "/JCVital_privacy_policy_zh",
      name: "/JCVital_privacy_policy_zh",
      component: (resolve) =>
        require(["@/pages/agreement/JCVital/privacy_policy_zh"], resolve),
    },
    {
      path: "/JCVital_privacy_policy_zhhk",
      name: "/JCVital_privacy_policy_zhhk",
      component: (resolve) =>
        require(["@/pages/agreement/JCVital/privacy_policy_zhhk"], resolve),
    },
    {
      path: "/JCVital_privacy_policy_en",
      name: "/JCVital_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/JCVital/privacy_policy_en"], resolve),
    },
    {
      path: "/RHband_user_agreement_zh",
      name: "/RHband_user_agreement_zh",
      component: (resolve) =>
        require(["@/pages/agreement/RHband/user_agreement_zh"], resolve),
    },
    {
      path: "/RHband_user_agreement_en",
      name: "/RHband_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/RHband/user_agreement_en"], resolve),
    },
    {
      path: "/RHband_privacy_policy_zh",
      name: "/RHband_privacy_policy_zh",
      component: (resolve) =>
        require(["@/pages/agreement/RHband/privacy_policy_zh"], resolve),
    },

    {
      path: "/RHband_privacy_policy_en",
      name: "/RHband_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/RHband/privacy_policy_en"], resolve),
    },

 {
      path: "/JCVitalPro_user_agreement_zh",
      name: "/JCVitalPro_user_agreement_zh",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/user_agreement_zh"], resolve),
    },
    {
      path: "/JCVitalPro_user_agreement_en",
      name: "/JCVitalPro_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/user_agreement_en"], resolve),
    },

    {
      path: "/JCVitalPro_user_agreement_fi",
      name: "/JCVitalPro_user_agreement_fi",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/user_agreement_fi"], resolve),
    },

    {
      path: "/JCVitalPro_user_agreement_ja",
      name: "/JCVitalPro_user_agreement_ja",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/user_agreement_ja"], resolve),
    },

    {
      path: "/JCVitalPro_user_agreement_pl",
      name: "/JCVitalPro_user_agreement_pl",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/user_agreement_pl"], resolve),
    },
    {
      path: "/JCRing_user_agreement_ru",
      name: "/JCRing_user_agreement_ru",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/user_agreement_ru"], resolve),
    },
    {
      path: "/JCVitalPro_user_agreement_vi",
      name: "/JCVitalPro_user_agreement_vi",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/user_agreement_vi"], resolve),
    },
    {
      path: "/JCVitalPro_user_agreement_ru",
      name: "/JCVitalPro_user_agreement_ru",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/user_agreement_ru"], resolve),
    },
    {
      path: "/JCVitalPro_user_agreement_zhhk",
      name: "/JCVitalPro_user_agreement_zhhk",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/user_agreement_zhhk"], resolve),
    },

    {
      path: "/JCVitalPro_user_agreement_es",
      name: "/JCVitalPro_user_agreement_es",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/user_agreement_es"], resolve),
    },

    {
      path: "/JCVitalPro_user_agreement_pt",
      name: "/JCVitalPro_user_agreement_pt",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/user_agreement_pt"], resolve),
    },

    {
      path: "/JCVitalPro_user_agreement_it",
      name: "/JCVitalPro_user_agreement_it",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/user_agreement_it"], resolve),
    },
    {
      path: "/JCVitalPro_user_agreement_de",
      name: "/JCVitalPro_user_agreement_de",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/user_agreement_de"], resolve),
    },
    {
      path: "/JCVitalPro_user_agreement_cs",
      name: "/JCVitalPro_user_agreement_cs",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/user_agreement_cs"], resolve),
    },
    {
      path: "/JCVitalPro_user_agreement_fr",
      name: "/JCVitalPro_user_agreement_fr",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/user_agreement_fr"], resolve),
    },
    {
      path: "/JCVitalPro_user_agreement_ko",
      name: "/JCVitalPro_user_agreement_ko",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/user_agreement_ko"], resolve),
    },
    {
      path: "/JCVitalPro_user_agreement_tr",
      name: "/JCVitalPro_user_agreement_tr",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/user_agreement_tr"], resolve),
    },
    {
      path: "/JCVitalPro_privacy_policy_ko",
      name: "/JCVitalPro_privacy_policy_ko",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/privacy_policy_ko"], resolve),
    },
    {
      path: "/JCVitalPro_privacy_policy_fr",
      name: "/JCVitalPro_privacy_policy_fr",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/privacy_policy_fr"], resolve),
    },

    {
      path: "/JCVitalPro_privacy_policy_cs",
      name: "/JCVitalPro_privacy_policy_cs",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/privacy_policy_cs"], resolve),
    },
    {
      path: "/JCVitalPro_privacy_policy_de",
      name: "/JCVitalPro_privacy_policy_de",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/privacy_policy_de"], resolve),
    },

    {
      path: "/JCVitalPro_privacy_policy_it",
      name: "/JCVitalPro_privacy_policy_it",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/privacy_policy_it"], resolve),
    },
    {
      path: "/JCVitalPro_privacy_policy_pt",
      name: "/JCVitalPro_privacy_policy_pt",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/privacy_policy_pt"], resolve),
    },
    {
      path: "/JCVitalPro_privacy_policy_es",
      name: "/JCVitalPro_privacy_policy_es",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/privacy_policy_es"], resolve),
    },

    {
      path: "/JCVitalPro_privacy_policy_ja",
      name: "/JCVitalPro_privacy_policy_ja",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/privacy_policy_ja"], resolve),
    },
    {
      path: "/JCVitalPro_privacy_policy_fi",
      name: "/JCVitalPro_privacy_policy_fi",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/privacy_policy_fi"], resolve),
    },

    {
      path: "/JCVitalPro_privacy_policy_zh",
      name: "/JCVitalPro_privacy_policy_zh",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/privacy_policy_zh"], resolve),
    },
    {
      path: "/JCVitalPro_privacy_policy_th",
      name: "/JCVitalPro_privacy_policy_th",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/privacy_policy_th"], resolve),
    },

    {
      path: "/JCVitalPro_privacy_policy_en",
      name: "/JCVitalPro_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/privacy_policy_en"], resolve),
    },
    {
      path: "/JCVitalPro_privacy_policy_ar",
      name: "/JCVitalPro_privacy_policy_ar",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/privacy_policy_ar"], resolve),
    },
    {
      path: "/JCVitalPro_privacy_policy_pl",
      name: "/JCVitalPro_privacy_policy_pl",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/privacy_policy_pl"], resolve),
    },
    {
      path: "/JCVitalPro_privacy_policy_vi",
      name: "/JCVitalPro_privacy_policy_vi",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/privacy_policy_vi"], resolve),
    },
    {
      path: "/JCVitalPro_privacy_policy_ru",
      name: "/JCVitalPro_privacy_policy_ru",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/privacy_policy_ru"], resolve),
    },
    {
      path: "/JCVitalPro_privacy_policy_tr",
      name: "/JCVitalPro_privacy_policy_tr",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/privacy_policy_tr"], resolve),
    },
    {
      path: "/JCVitalPro_privacy_policy_zhhk",
      name: "/JCVitalPro_privacy_policy_zhhk",
      component: (resolve) =>
        require(["@/pages/agreement/JCVitalPro/privacy_policy_zhhk"], resolve),
    },

    {
      path: "/XBAND_user_agreement_zh",
      name: "/XBAND_user_agreement_zh",
      component: (resolve) =>
        require(["@/pages/agreement/XBAND/user_agreement_zh"], resolve),
    },
    {
      path: "/XBAND_user_agreement_en",
      name: "/XBAND_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/XBAND/user_agreement_en"], resolve),
    },
    {
      path: "/XBAND_privacy_policy_zh",
      name: "/XBAND_privacy_policy_zh",
      component: (resolve) =>
        require(["@/pages/agreement/XBAND/privacy_policy_zh"], resolve),
    },
    {
      path: "/XBAND_privacy_policy_en",
      name: "/XBAND_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/XBAND/privacy_policy_en"], resolve),
    },

    {
      path: "/Rophie-R_user_agreement_zh",
      name: "/Rophie-R_user_agreement_zh",
      component: (resolve) =>
        require(["@/pages/agreement/Rophie-R/user_agreement_zh"], resolve),
    },
    {
      path: "/Rophie-R_user_agreement_en",
      name: "/Rophie-R_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/Rophie-R/user_agreement_en"], resolve),
    },
    {
      path: "/Rophie-R_privacy_policy_zh",
      name: "/Rophie-R_privacy_policy_zh",
      component: (resolve) =>
        require(["@/pages/agreement/Rophie-R/privacy_policy_zh"], resolve),
    },
    {
      path: "/Rophie-R_privacy_policy_en",
      name: "/Rophie-R_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/Rophie-R/privacy_policy_en"], resolve),
    },

    {
      path: "/Nextring_user_agreement_zh",
      name: "/Nextring_user_agreement_zh",
      component: (resolve) =>
        require(["@/pages/agreement/Nextring/user_agreement_zh"], resolve),
    },
    {
      path: "/Nextring_user_agreement_en",
      name: "/Nextring_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/Nextring/user_agreement_en"], resolve),
    },
    {
      path: "/Nextring_user_agreement_de",
      name: "/Nextring_user_agreement_de",
      component: (resolve) =>
        require(["@/pages/agreement/Nextring/user_agreement_de"], resolve),
    },
    {
      path: "/Nextring_user_agreement_it",
      name: "/Nextring_user_agreement_it",
      component: (resolve) =>
        require(["@/pages/agreement/Nextring/user_agreement_it"], resolve),
    },
    {
      path: "/Nextring_privacy_policy_zh",
      name: "/Nextring_privacy_policy_zh",
      component: (resolve) =>
        require(["@/pages/agreement/Nextring/privacy_policy_zh"], resolve),
    },
    {
      path: "/Nextring_privacy_policy_en",
      name: "/Nextring_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/Nextring/privacy_policy_en"], resolve),
    },
    {
      path: "/Nextring_privacy_policy_de",
      name: "/Nextring_privacy_policy_de",
      component: (resolve) =>
        require(["@/pages/agreement/Nextring/privacy_policy_de"], resolve),
    },

    {
      path: "/Nextring_privacy_policy_it",
      name: "/Nextring_privacy_policy_it",
      component: (resolve) =>
        require(["@/pages/agreement/Nextring/privacy_policy_it"], resolve),
    },

    {
      path: "/YouhongResearch_privacy_policy_zh",
      name: "/YouhongResearch_privacy_policy_zh",
      component: (resolve) =>
        require([
          "@/pages/agreement/YouhongResearch/privacy_policy_zh",
        ], resolve),
    },

    {
      path: "/YouhongResearch_privacy_policy_en",
      name: "/YouhongResearch_privacy_policy_en",
      component: (resolve) =>
        require([
          "@/pages/agreement/YouhongResearch/privacy_policy_en",
        ], resolve),
    },

    {
      path: "/YouhongResearch_user_agreement_zh",
      name: "/YouhongResearch_user_agreement_zh",
      component: (resolve) =>
        require([
          "@/pages/agreement/YouhongResearch/user_agreement_zh",
        ], resolve),
    },
    {
      path: "/YouhongResearch_user_agreement_en",
      name: "/YouhongResearch_user_agreement_en",
      component: (resolve) =>
        require([
          "@/pages/agreement/YouhongResearch/user_agreement_en",
        ], resolve),
    },

    {
      path: "/SeekZero_user_agreement_th",
      name: "/SeekZero_user_agreement_th",
      component: (resolve) =>
        require(["@/pages/agreement/SeekZero/user_agreement_th"], resolve),
    },
    {
      path: "/SeekZero_user_agreement_zh",
      name: "/SeekZero_user_agreement_zh",
      component: (resolve) =>
        require(["@/pages/agreement/SeekZero/user_agreement_zh"], resolve),
    },
    {
      path: "/SeekZero_user_agreement_en",
      name: "/SeekZero_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/SeekZero/user_agreement_en"], resolve),
    },

    {
      path: "/SeekZero_user_agreement_fi",
      name: "/SeekZero_user_agreement_fi",
      component: (resolve) =>
        require(["@/pages/agreement/SeekZero/user_agreement_fi"], resolve),
    },

    {
      path: "/SeekZero_user_agreement_ja",
      name: "/SeekZero_user_agreement_ja",
      component: (resolve) =>
        require(["@/pages/agreement/SeekZero/user_agreement_ja"], resolve),
    },

    {
      path: "/SeekZero_user_agreement_pl",
      name: "/SeekZero_user_agreement_pl",
      component: (resolve) =>
        require(["@/pages/agreement/SeekZero/user_agreement_pl"], resolve),
    },
    {
      path: "/SeekZero_user_agreement_ru",
      name: "/SeekZero_user_agreement_ru",
      component: (resolve) =>
        require(["@/pages/agreement/SeekZero/user_agreement_ru"], resolve),
    },
    {
      path: "/SeekZero_user_agreement_vi",
      name: "/SeekZero_user_agreement_vi",
      component: (resolve) =>
        require(["@/pages/agreement/SeekZero/user_agreement_vi"], resolve),
    },
    {
      path: "/SeekZero_user_agreement_ru",
      name: "/SeekZero_user_agreement_ru",
      component: (resolve) =>
        require(["@/pages/agreement/SeekZero/user_agreement_ru"], resolve),
    },
    {
      path: "/SeekZero_user_agreement_zhhk",
      name: "/SeekZero_user_agreement_zhhk",
      component: (resolve) =>
        require(["@/pages/agreement/SeekZero/user_agreement_zhhk"], resolve),
    },

    {
      path: "/SeekZero_privacy_policy_ja",
      name: "/SeekZero_privacy_policy_ja",
      component: (resolve) =>
        require(["@/pages/agreement/SeekZero/privacy_policy_ja"], resolve),
    },
    {
      path: "/SeekZero_privacy_policy_fi",
      name: "/SeekZero_privacy_policy_fi",
      component: (resolve) =>
        require(["@/pages/agreement/SeekZero/privacy_policy_fi"], resolve),
    },

    {
      path: "/SeekZero_privacy_policy_zh",
      name: "/SeekZero_privacy_policy_zh",
      component: (resolve) =>
        require(["@/pages/agreement/SeekZero/privacy_policy_zh"], resolve),
    },
    {
      path: "/SeekZero_privacy_policy_th",
      name: "/SeekZero_privacy_policy_th",
      component: (resolve) =>
        require(["@/pages/agreement/SeekZero/privacy_policy_th"], resolve),
    },

    {
      path: "/SeekZero_privacy_policy_en",
      name: "/SeekZero_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/SeekZero/privacy_policy_en"], resolve),
    },
    {
      path: "/SeekZero_privacy_policy_ar",
      name: "/SeekZero_privacy_policy_ar",
      component: (resolve) =>
        require(["@/pages/agreement/SeekZero/privacy_policy_ar"], resolve),
    },
    {
      path: "/SeekZero_privacy_policy_pl",
      name: "/SeekZero_privacy_policy_pl",
      component: (resolve) =>
        require(["@/pages/agreement/SeekZero/privacy_policy_pl"], resolve),
    },
    {
      path: "/SeekZero_privacy_policy_vi",
      name: "/SeekZero_privacy_policy_vi",
      component: (resolve) =>
        require(["@/pages/agreement/SeekZero/privacy_policy_vi"], resolve),
    },
    {
      path: "/SeekZero_privacy_policy_ru",
      name: "/SeekZero_privacy_policy_ru",
      component: (resolve) =>
        require(["@/pages/agreement/SeekZero/privacy_policy_ru"], resolve),
    },
    {
      path: "/SeekZero_privacy_policy_zhhk",
      name: "/SeekZero_privacy_policy_zhhk",
      component: (resolve) =>
        require(["@/pages/agreement/SeekZero/privacy_policy_zhhk"], resolve),
    },

    {
      path: "/DIIKENRING_user_agreement_zh",
      name: "/DIIKENRING_user_agreement_zh",
      component: (resolve) =>
        require(["@/pages/agreement/DIIKENRING/user_agreement_zh"], resolve),
    },
    {
      path: "/DIIKENRING_user_agreement_en",
      name: "/DIIKENRING_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/DIIKENRING/user_agreement_en"], resolve),
    },
    {
      path: "/DIIKENRING_privacy_policy_zh",
      name: "/DIIKENRING_privacy_policy_zh",
      component: (resolve) =>
        require(["@/pages/agreement/DIIKENRING/privacy_policy_zh"], resolve),
    },
    {
      path: "/DIIKENRING_privacy_policy_en",
      name: "/DIIKENRING_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/DIIKENRING/privacy_policy_en"], resolve),
    },

    {
      path: "/OLOMRING_user_agreement_zh",
      name: "/OLOMRING_user_agreement_zh",
      component: (resolve) =>
        require(["@/pages/agreement/OLOMRING/user_agreement_zh"], resolve),
    },
    {
      path: "/OLOMRING_user_agreement_en",
      name: "/OLOMRING_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/OLOMRING/user_agreement_en"], resolve),
    },
    {
      path: "/OLOMRING_privacy_policy_zh",
      name: "/OLOMRING_privacy_policy_zh",
      component: (resolve) =>
        require(["@/pages/agreement/OLOMRING/privacy_policy_zh"], resolve),
    },
    {
      path: "/OLOMRING_privacy_policy_en",
      name: "/OLOMRING_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/OLOMRING/privacy_policy_en"], resolve),
    },

    {
      path: "/SAMRing_user_agreement_zh",
      name: "/SAMRing_user_agreement_zh",
      component: (resolve) =>
        require(["@/pages/agreement/SAMRing/user_agreement_zh"], resolve),
    },
    {
      path: "/SAMRing_user_agreement_en",
      name: "/SAMRing_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/SAMRing/user_agreement_en"], resolve),
    },
    {
      path: "/SAMRing_privacy_policy_zh",
      name: "/SAMRing_privacy_policy_zh",
      component: (resolve) =>
        require(["@/pages/agreement/SAMRing/privacy_policy_zh"], resolve),
    },
    {
      path: "/SAMRing_privacy_policy_en",
      name: "/SAMRing_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/SAMRing/privacy_policy_en"], resolve),
    },

    {
      path: "/ONEKISSSmartRing_user_agreement_zh",
      name: "/ONEKISSSmartRing_user_agreement_zh",
      component: (resolve) =>
        require([
          "@/pages/agreement/ONEKISSSmartRing/user_agreement_zh",
        ], resolve),
    },
    {
      path: "/ONEKISSSmartRing_user_agreement_zhhk",
      name: "/ONEKISSSmartRing_user_agreement_zhhk",
      component: (resolve) =>
        require([
          "@/pages/agreement/ONEKISSSmartRing/user_agreement_zhhk",
        ], resolve),
    },
    {
      path: "/ONEKISSSmartRing_user_agreement_en",
      name: "/ONEKISSSmartRing_user_agreement_en",
      component: (resolve) =>
        require([
          "@/pages/agreement/ONEKISSSmartRing/user_agreement_en",
        ], resolve),
    },
    {
      path: "/ONEKISSSmartRing_privacy_policy_zhhk",
      name: "/ONEKISSSmartRing_privacy_policy_zhhk",
      component: (resolve) =>
        require([
          "@/pages/agreement/ONEKISSSmartRing/privacy_policy_zhhk",
        ], resolve),
    },
    {
      path: "/ONEKISSSmartRing_privacy_policy_zh",
      name: "/ONEKISSSmartRing_privacy_policy_zh",
      component: (resolve) =>
        require([
          "@/pages/agreement/ONEKISSSmartRing/privacy_policy_zh",
        ], resolve),
    },
    {
      path: "/ONEKISSSmartRing_privacy_policy_en",
      name: "/ONEKISSSmartRing_privacy_policy_en",
      component: (resolve) =>
        require([
          "@/pages/agreement/ONEKISSSmartRing/privacy_policy_en",
        ], resolve),
    },

    {
      path: "/FOSMETRING_user_agreement_zh",
      name: "/FOSMETRING_user_agreement_zh",
      component: (resolve) =>
        require(["@/pages/agreement/FOSMETRING/user_agreement_zh"], resolve),
    },
    {
      path: "/FOSMETRING_user_agreement_en",
      name: "/FOSMETRING_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/FOSMETRING/user_agreement_en"], resolve),
    },
    {
      path: "/FOSMETRING_user_agreement_ja",
      name: "/FOSMETRING_user_agreement_ja",
      component: (resolve) =>
        require(["@/pages/agreement/FOSMETRING/user_agreement_ja"], resolve),
    },
    {
      path: "/FOSMETRING_privacy_policy_zh",
      name: "/FOSMETRING_privacy_policy_zh",
      component: (resolve) =>
        require(["@/pages/agreement/FOSMETRING/privacy_policy_zh"], resolve),
    },
    {
      path: "/FOSMETRING_privacy_policy_en",
      name: "/FOSMETRING_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/FOSMETRING/privacy_policy_en"], resolve),
    },
    {
      path: "/FOSMETRING_privacy_policy_ja",
      name: "/FOSMETRING_privacy_policy_ja",
      component: (resolve) =>
        require(["@/pages/agreement/FOSMETRING/privacy_policy_ja"], resolve),
    },

    // motions

    {
      path: "/motionsRing_user_agreement_en",
      name: "/motionsRing_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/motionsRing/user_agreement_en"], resolve),
    },

    {
      path: "/motionsRing_user_agreement_tr",
      name: "/motionsRing_user_agreement_tr",
      component: (resolve) =>
        require(["@/pages/agreement/motionsRing/user_agreement_tr"], resolve),
    },

    {
      path: "/motionsRing_privacy_policy_en",
      name: "/motionsRing_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/motionsRing/privacy_policy_en"], resolve),
    },
    {
      path: "/motionsRing_privacy_policy_tr",
      name: "/motionsRing_privacy_policy_tr",
      component: (resolve) =>
        require(["@/pages/agreement/motionsRing/privacy_policy_tr"], resolve),
    },

    {
      path: "/JCRingPro_user_agreement_zh",
      name: "/JCRingPro_user_agreement_zh",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/user_agreement_zh"], resolve),
    },
    {
      path: "/JCRingPro_user_agreement_en",
      name: "/JCRingPro_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/user_agreement_en"], resolve),
    },

    {
      path: "/JCRingPro_user_agreement_fi",
      name: "/JCRingPro_user_agreement_fi",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/user_agreement_fi"], resolve),
    },

    {
      path: "/JCRingPro_user_agreement_ja",
      name: "/JCRingPro_user_agreement_ja",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/user_agreement_ja"], resolve),
    },

    {
      path: "/JCRingPro_user_agreement_pl",
      name: "/JCRingPro_user_agreement_pl",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/user_agreement_pl"], resolve),
    },
    {
      path: "/JCRing_user_agreement_ru",
      name: "/JCRing_user_agreement_ru",
      component: (resolve) =>
        require(["@/pages/agreement/JCRing/user_agreement_ru"], resolve),
    },
    {
      path: "/JCRingPro_user_agreement_vi",
      name: "/JCRingPro_user_agreement_vi",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/user_agreement_vi"], resolve),
    },
    {
      path: "/JCRingPro_user_agreement_ru",
      name: "/JCRingPro_user_agreement_ru",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/user_agreement_ru"], resolve),
    },
    {
      path: "/JCRingPro_user_agreement_zhhk",
      name: "/JCRingPro_user_agreement_zhhk",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/user_agreement_zhhk"], resolve),
    },

    {
      path: "/JCRingPro_user_agreement_es",
      name: "/JCRingPro_user_agreement_es",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/user_agreement_es"], resolve),
    },

    {
      path: "/JCRingPro_user_agreement_pt",
      name: "/JCRingPro_user_agreement_pt",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/user_agreement_pt"], resolve),
    },

    {
      path: "/JCRingPro_user_agreement_it",
      name: "/JCRingPro_user_agreement_it",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/user_agreement_it"], resolve),
    },
    {
      path: "/JCRingPro_user_agreement_de",
      name: "/JCRingPro_user_agreement_de",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/user_agreement_de"], resolve),
    },
    {
      path: "/JCRingPro_user_agreement_cs",
      name: "/JCRingPro_user_agreement_cs",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/user_agreement_cs"], resolve),
    },
    {
      path: "/JCRingPro_user_agreement_fr",
      name: "/JCRingPro_user_agreement_fr",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/user_agreement_fr"], resolve),
    },
    {
      path: "/JCRingPro_user_agreement_ko",
      name: "/JCRingPro_user_agreement_ko",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/user_agreement_ko"], resolve),
    },
    {
      path: "/JCRingPro_user_agreement_tr",
      name: "/JCRingPro_user_agreement_tr",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/user_agreement_tr"], resolve),
    },
    {
      path: "/JCRingPro_privacy_policy_ko",
      name: "/JCRingPro_privacy_policy_ko",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/privacy_policy_ko"], resolve),
    },
    {
      path: "/JCRingPro_privacy_policy_fr",
      name: "/JCRingPro_privacy_policy_fr",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/privacy_policy_fr"], resolve),
    },

    {
      path: "/JCRingPro_privacy_policy_cs",
      name: "/JCRingPro_privacy_policy_cs",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/privacy_policy_cs"], resolve),
    },
    {
      path: "/JCRingPro_privacy_policy_de",
      name: "/JCRingPro_privacy_policy_de",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/privacy_policy_de"], resolve),
    },

    {
      path: "/JCRingPro_privacy_policy_it",
      name: "/JCRingPro_privacy_policy_it",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/privacy_policy_it"], resolve),
    },
    {
      path: "/JCRingPro_privacy_policy_pt",
      name: "/JCRingPro_privacy_policy_pt",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/privacy_policy_pt"], resolve),
    },
    {
      path: "/JCRingPro_privacy_policy_es",
      name: "/JCRingPro_privacy_policy_es",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/privacy_policy_es"], resolve),
    },

    {
      path: "/JCRingPro_privacy_policy_ja",
      name: "/JCRingPro_privacy_policy_ja",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/privacy_policy_ja"], resolve),
    },
    {
      path: "/JCRingPro_privacy_policy_fi",
      name: "/JCRingPro_privacy_policy_fi",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/privacy_policy_fi"], resolve),
    },

    {
      path: "/JCRingPro_privacy_policy_zh",
      name: "/JCRingPro_privacy_policy_zh",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/privacy_policy_zh"], resolve),
    },
    {
      path: "/JCRingPro_privacy_policy_th",
      name: "/JCRingPro_privacy_policy_th",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/privacy_policy_th"], resolve),
    },

    {
      path: "/JCRingPro_privacy_policy_en",
      name: "/JCRingPro_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/privacy_policy_en"], resolve),
    },
    {
      path: "/JCRingPro_privacy_policy_ar",
      name: "/JCRingPro_privacy_policy_ar",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/privacy_policy_ar"], resolve),
    },
    {
      path: "/JCRingPro_privacy_policy_pl",
      name: "/JCRingPro_privacy_policy_pl",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/privacy_policy_pl"], resolve),
    },
    {
      path: "/JCRingPro_privacy_policy_vi",
      name: "/JCRingPro_privacy_policy_vi",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/privacy_policy_vi"], resolve),
    },
    {
      path: "/JCRingPro_privacy_policy_ru",
      name: "/JCRingPro_privacy_policy_ru",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/privacy_policy_ru"], resolve),
    },
    {
      path: "/JCRingPro_privacy_policy_tr",
      name: "/JCRingPro_privacy_policy_tr",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/privacy_policy_tr"], resolve),
    },
    {
      path: "/JCRingPro_privacy_policy_zhhk",
      name: "/JCRingPro_privacy_policy_zhhk",
      component: (resolve) =>
        require(["@/pages/agreement/JCRingPro/privacy_policy_zhhk"], resolve),
    },
    {
      path: "/LWH_user_agreement_en",
      name: "/LWH_user_agreement_en",
      component: (resolve) =>
        require(["@/pages/agreement/LWH/user_agreement_en"], resolve),
    },
    {
      path: "/LWH_privacy_policy_en",
      name: "/LWH_privacy_policy_en",
      component: (resolve) =>
        require(["@/pages/agreement/LWH/privacy_policy_en"], resolve),
    },
  ],

  // 记录离开也面前滚动的位置，配合缓存使用
  scrollBehavior(to, from, savedPosition) {
    // 优先使用保存的位置
    if (savedPosition) return savedPosition;

    // 为keepAlive组件保存滚动位置
    if (from.meta.keepAlive) {
      from.meta.savedPosition = document.body.scrollTop;
    }

    // 默认返回顶部，保持历史位置或0
    return { x: 0, y: to.meta.savedPosition || 0 };
  },
});



// WEBPACK FOOTER //
// ./src/router/index.js